<template>
  <ContentContainer :loadingStatus="isLoading">
    <div class="content-wrapper">
      <div class="page-header">{{ $t('termsAndConditions') }}</div>
      <div class="item" v-for="(term, index) in termsAndConditions.dataList" :key="index">
        <div class="term-title">{{term.title}}</div>
        <div class="detail">{{getDetail(term)}}</div>
      </div>
      <el-row class="edit-remark">
        <el-button type="primary" @click="onEditButtonClick">{{ $t('editTermsAndConditions') }}</el-button>
      </el-row>
    </div>
  </ContentContainer>
</template>

<script>
import i18nMessages from '@/translations/Hotel/ManageHotel/TermsAndConditions/Index.i18n'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import HotelTermsAndConditionsApi from '@/api/hotel/terms-and-conditions-api'
import ContentContainer from '@/components/ContentContainerComponent.vue'
import LocalStorageFactory from '@/factories/local-storage-factory'
import { getHotelIndexRoute } from '@/services/hotel-service'
import { mapState } from 'vuex'
import { bindData } from '@/helpers'

export default {
  name: 'HotelTermsAndConditions',
  mixins: [AlertViewMixin],
  components: { ContentContainer },
  i18n: { messages: i18nMessages },
  created: async function () {
    if (this.activeHotelId === undefined || this.activeHotelId === '') {
      const companyDetail = LocalStorageFactory.getCompanyDetail()
      const routeName = await getHotelIndexRoute(companyDetail, this.$store)

      return this.$router.push({
        name: routeName
      })
    }

    try {
      await this.getTermsAndConditions(this.activeHotelId)
    } catch (err) {
      this.alertError(err.message)
    }
  },
  computed: {
    ...mapState({
      activeHotelId: state => state.general.activeHotelId
    })
  },
  data () {
    return {
      isLoading: false,
      termsAndConditions: {
        hotelId: '',
        companyId: '',
        dataList: [],
        id: ''
      }
    }
  },
  methods: {
    getTermsAndConditions: async function (hotelId) {
      this.isLoading = true
      try {
        this.termsAndConditions = await HotelTermsAndConditionsApi.list(hotelId)
      } catch (err) {
        this.alertError(err.message)
      }
      this.isLoading = false
    },
    getDetail: function (termAndCondition) {
      return bindData(termAndCondition, 'detail')
    },
    onEditButtonClick: function () {
      this.$router.push({
        name: 'HotelTermsAndConditionsEdit',
        params: {
          termsAndConditions: this.termsAndConditions
        }
      })
    }
  }
}
</script>

<style scoped>
  .el-header {
    background-color: #f8f9fa;
    color: #2c3e50;
    text-align: left;
    min-height: 60px;
    font-size: 14px;
    padding-top: 10px;
    margin-bottom: 20px;
  }
  .detail {
    white-space: pre-line;
  }
  .edit-remark {
    margin-top: 20px;
  }
  .term-title {
    text-transform: uppercase;
    font-size: 16px;
    font-weight: bold;

  }
  .item {
    background-color: #f8f9fa;
    color: #2c3e50;
    text-align: left;
    font-size: 14px;
    padding: 15px;
    margin-bottom: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
  }
</style>
